module.exports = __webpack_public_path__ + "img/Humi&CO2.8ac63001.jpg";